/* Add c_backgroundColor Aug 24, 2024 */
/* Add p_readOnly,p_required for read only columns  Feb 1, 2025 */
/* GUI changes Phase 1 May 15, 2026 */
<template lang="pug">
b-input-group-prepend(class="kt-com-fld")
		b-input-group-text(@click="m_click" :class="c_clk?'clk':null")
			fa-icon(v-if="c_icon" :icon="c_icon" :color="c_color")
			span(v-else) {{typ}}
		b-form-input(v-if="p_mode=='view'||p_readOnly" disabled :value="c_formatter"  size="sm" class="styled-input")
		b-form-input(v-else-if="typ=='@'" :required="p_required" :value="value" @input="m_input" size="sm" :placeholder="placeholder" class="styled-input")
		b-form-input(v-else-if="typ=='w'" :required="p_required" :value="value" @input="m_input" size="sm" :placeholder="placeholder" class="styled-input")
		b-form-input(v-else :required="p_required" :value="value" @input="m_input" size="sm" :placeholder="placeholder"  onkeypress="return [40,41,43,44,45,46].includes(event.charCode)||(event.charCode>=48 && event.charCode<=57)" class="styled-input")
</template>
<script>
export default {
	name: "kt-com-fld",
	props: {
		value: String,
		placeholder: String,
		typ: String,
		id:String,
		p_mode:String,
		p_readOnly:Boolean,
		p_required: {type: Boolean, default: false},
  },
	created() {},
	mounted(){
	
				document.getElementsByTagName('input')||[].forEach(i=>
								{
								console.log(i.id);
								var _this=this;
								i.addEventListener("focus", (event) => {
								console.log(`focus on ${i.id}`);
								this.$emit("focused",i.id);
								});
								
								});
	},
  computed: {
    c_icon() {
      switch (this.typ) {
        case "w":
          return "external-link-alt";
        case "p":
          return "phone";
        case "pm":
          return "mobile-alt";
        case "po":
          return "building";
        case "f":
          return "fax";
        default:
          return null;
		}
	  },
    c_color() {
      switch (this.typ) {
        case "p":
          return "#007bff";
        case "pm":
          return "#fd7e14"  //"#ffc107";
        case "f":
          return "#28a745";
        default:
          return null;
      }
    },
    c_clk() {
      return this.value && /^w|@|p|pm|po|f$/.test(this.typ);
    },
	c_formatter(){
		if(!this.value) return null;
		let retVal=this.value;
		if(['p','pm','f','po'].includes(this.typ)){
			let pattern = /-|\.|,/;
			if(!pattern.test(this.value))
				retVal=this.value.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3');
			}
		return retVal;
    },
  },
  methods: {
    m_click() {
      if (!this.c_clk) return;

      let val = this.value;

      switch (this.typ) {
        case "w": {
          let h = "http";
          let href = val.startsWith(h) ? val : h + "://" + val;
          window.open(href, "_blank");
          break;
        }
        case "@": {
          window.open(`mailto:${val}`, "_blank");
          break;
        }
        case "p":
        case "pm":
		case "f":
        case "po": {
          var a = document.createElement("a");
          a.href = `tel:${val}`;
          a.click();
          break;
        }
      }
    },
    m_input(e) {
      this.$emit("input", e);
    },	
	m_formatter(value){
		let retVal=value;
		if(['p','pm','f'].includes(this.typ)){
			if(!(value?.includes(".")||value?.includes("-")||value?.includes("(")))
				retVal=value.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3');
		}
		return retVal;
	} 
	
  },
};
</script>

<style lang="less">
.kt-com-fld {
  > .input-group-text {
    &.clk {
      cursor: pointer;
    }
    &:not(.clk) {
      cursor: default;
    }
  }
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
input {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid black;
}
input:disabled{
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
input:focus{
  border-color: transparent;
  border-bottom: 1px solid #ddd;   //1px solid #428bca;
  box-shadow: none;
}
</style>
